import React, { useCallback, useEffect, useState } from 'react'
import '../components/ReviewRequests.css'

export default function ReviewPreferencesPage() {
  const [token] = useState(() => window.location.hash.slice(1))
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const submit = useCallback(async action => {
    setBusy(true); setError('')
    try {
      const response = await fetch('/.netlify/functions/review-preferences', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, action }) })
      const result = await response.json()
      if (!response.ok) throw new Error(result.error || 'Preference unavailable.')
      setData(result.data)
    } catch (e) { setError(e.message) }
    finally { setBusy(false) }
  }, [token])
  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname)
    submit('read')
    // Read once, never revoke on page load. The fragment never reaches access logs.
  }, [submit])
  return <main className="review-public card"><h1>Review email preferences</h1>
    {error && <p role="alert">{error}</p>}{busy && <p role="status">Checking your preference…</p>}
    {data && <><h2>{data.workshop_name}</h2>{data.revoked ? <p role="status">Review invitations are stopped. Your essential service emails are unaffected.</p>
      : <><p>You can stop optional Google review invitations from this workshop. Your service and essential job emails are unaffected.</p>
        <button className="btn btn-primary" type="button" disabled={busy} onClick={() => submit('revoke')}>Stop review invitations</button></>}</>}
    {error && <button className="btn btn-secondary" disabled={busy} onClick={() => submit('read')}>Try again</button>}
  </main>
}
